import { Skeleton } from "../ui/skeleton";

export const GenericPageSkeleton = () => {
  return (
    <div
      className="min-h-screen bg-background"
      role="status"
      aria-live="polite"
      aria-busy="true"
      aria-label="Loading page content"
    >
      <div className="container mx-auto px-4 lg:px-8 py-10 space-y-8">
        <div className="space-y-4 max-w-2xl">
          <Skeleton className="h-10 w-64 rounded-xl" />
          <Skeleton className="h-5 w-full max-w-xl rounded-lg" />
        </div>
        <div className="grid grid-cols-1 md:grid-cols-3 gap-6 pt-4">
          <Skeleton className="h-44 rounded-2xl" />
          <Skeleton className="h-44 rounded-2xl" />
          <Skeleton className="h-44 rounded-2xl" />
        </div>
        <div className="space-y-4 pt-4 max-w-4xl">
          <Skeleton className="h-6 w-48 rounded-lg" />
          <Skeleton className="h-24 w-full rounded-2xl" />
          <Skeleton className="h-24 w-full rounded-2xl" />
        </div>
      </div>
    </div>
  );
};
